import Header from "../../common/Header";
import Footer from "../../common/Footer";
import Guardian from "../../compnents/create/Guardian";
import ContractEditor from "../../compnents/create/ContractEditor";
import { useState } from "react";
import Payment from "../../compnents/create/Payment";
import Student from "../../compnents/create/StudentInfo";
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FormControl, InputLabel, Select, MenuItem, Box, Typography } from "@mui/material";

const API_URL = "http://localhost:3030";
const API_URL2 = process.env.REACT_APP_API_URL;

export default function EditContract() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [contractYears, setContractYears] = useState([]);
  const [selectedContractYear, setSelectedContractYear] = useState('');
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  // Define the initial state for `guardian`
  const [guardian, setGuardian] = useState({
    name: "",
    idNumber: "",
    relationship: "",
    absherMobileNumber: "",
    additionalMobileNumber: "",
    residentialAddress: "",
    profession: "",
    workAddress: "",
    workPhoneNumber: "",
    extension: "",
    contactPersons: [
      {
        name: "",
        relationship: "",
        mobileNumber: "",
      },
      {
        name: "",
        relationship: "",
        mobileNumber: "",
      },
    ],
  });

  // Define the state for `contractEditor`
  const [contractEditor, setContractEditor] = useState({
    name: "",
    idNumber: "",
    relationship: "",
    absherMobileNumber: "",
    additionalMobileNumber: "",
    residentialAddress: "",
    profession: "",
    workAddress: "",
    workPhoneNumber: "",
    extension: "",
    educationalContact: {
      name: "",
      relationship: "",
      mobileNumber: "",
    },
    financialContact: {
      name: "",
      relationship: "",
      mobileNumber: "",
    },
  });

  // Define the initial state for `student`
  const [student, setStudent] = useState({
    name: "",
    nationality: "",
    birthPlace: "",
    birthDate: "",
    idNumber: "",
    idIssueDate: "",
    idIssuePlace: "",
    previouslyEnrolled: false,
    hasRelation: null,
    relationshipName: "",
    previousSchoolName: "",
    previousSchoolCity: "",
    previousSchoolType: "",
    requiredSchool: "",
    requiredStage: "",
    requiredGrade: "",
    hasSiblingsInIthraa: false,
    siblings: [
      {
        name: "",
        school: "",
        stage: "",
        grade: "",
      },
    ],
  });

  // Define the initial state for `payment`
  const [payment, setPayment] = useState({
    paymentType: "Annual", // Default value
    transportation: {
      required: false, // Default value
      neighborhood: "",
      path: "One path", // Default value
    },
    // American Path Selection
    isKindergartenAmerican: false,
    isElementaryAmerican: false,
  });

  // Path selection state
  const [selectedPath, setSelectedPath] = useState('public'); // Default to public path

  // Format date to YYYY-MM-DD for input fields
  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    // Handle different date formats
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return ''; // Invalid date
    
    // Format to YYYY-MM-DD
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Fetch contract years and current contract data
  useEffect(() => {
    // Fetch available contract years
    const fetchContractYears = async () => {
      try {
        const response = await fetch(`${API_URL2}/api/contract-variables`, {
          credentials: 'include',
        });
        
        if (!response.ok) throw new Error('Failed to fetch contract years');
        
        const data = await response.json();
        if (!data.data || !Array.isArray(data.data)) {
          throw new Error('Invalid data format received');
        }

        const years = data.data.map(contract => ({
          id: contract._id,
          year: `${contract.contractYear}_${contract.contractYearHijri}`,
          isActive: contract.isActive
        }));

        setContractYears(years);
      } catch (err) {
        console.error('Error fetching contract years:', err);
        alert('حدث خطأ أثناء جلب السنوات الدراسية');
      }
    };

    // Fetch current contract data
    const fetchContractData = async () => {
      try {
        const response = await fetch(`${API_URL2}/api/admin/get/${id}`, {
          credentials: "include",
        });
        const data = await response.json();
        
        if (data.success) {
          setGuardian(data.data.guardian);
          setContractEditor(data.data.contractEditor);
          const previouslyEnrolled =
            data.data.student.previouslyEnrolled === true ||
            data.data.student.previouslyEnrolled === "true";

          // Format dates for the student data
          const formattedStudentData = {
            ...data.data.student,
            previouslyEnrolled,
            birthDate: formatDateForInput(data.data.student.birthDate),
            idIssueDate: formatDateForInput(data.data.student.idIssueDate),
            // Defaults for newly added fields to ensure UI loads them
            hasRelation:
              data.data.student.hasRelation === true ||
              data.data.student.hasRelation === "true"
                ? true
                : data.data.student.hasRelation === false ||
                  data.data.student.hasRelation === "false"
                ? false
                : null,
            relationshipName: data.data.student.relationshipName || "",
          };

          setStudent(formattedStudentData);
          setPayment(data.data.payment);
          
          // Set the selected contract year if it exists
          if (data.data.contractYear) {
            setSelectedContractYear(data.data.contractYear);
          }

          // Determine the selected path based on payment data
          if (data.data.payment) {
            if (data.data.payment.isKindergartenAmerican || data.data.payment.isElementaryAmerican) {
              setSelectedPath('american');
            } else {
              setSelectedPath('public');
            }
          }
        } else {
          alert("فشل تحميل بيانات العقد.");
        }
      } catch (error) {
        console.error("Error fetching contract:", error);
        alert("حدث خطأ أثناء تحميل بيانات العقد");
      }
    };

    fetchContractYears();
    fetchContractData();
  }, [id]);

  return (
    <>
      <Header />
      
      {/* Popup Styles */}
      <style>
        {`
          .popup-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 9999;
          }
          
          .popup-card {
            background: white;
            border-radius: 12px;
            padding: 30px;
            text-align: center;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
            max-width: 400px;
            width: 90%;
          }
          
          .popup-content {
            direction: rtl;
          }
          
          .popup-icon {
            font-size: 48px;
            margin-bottom: 20px;
          }
          
          .popup-content h4 {
            color: #28a745;
            margin-bottom: 15px;
            font-weight: bold;
          }
          
          .popup-content p {
            color: #666;
            margin: 0;
          }
        `}
      </style>
      
      {/* Success Popup Overlay */}
      {showSuccessPopup && (
        <div className="popup-overlay">
          <div className="popup-card">
            <div className="popup-content">
              <div className="popup-icon">✅</div>
              <h4>تم تعديل العقد بنجاح!</h4>
            </div>
          </div>
        </div>
      )}
      
      <div dir="rtl" className="container mt-2">
        <h2 className="fw-bold">تعديل عقد تسجيل طالب</h2>
        
        {/* Path Selection Indicator */}
        <div className="alert alert-info text-center mb-3" role="alert">
          <strong>المسار المختار:</strong> 
          {selectedPath === 'american' ? (
            <span className="text-primary">المسار الأمريكي والدبلوم الأمريكي (عالمي)</span>
          ) : (
            <span className="text-success">المسار الأهلي (وطني)</span>
          )}
        </div>
        
        <hr />

        {/* Contract Year Selection */}
        <Box sx={{ mb: 3 }}>
          <FormControl fullWidth required>
            <InputLabel>السنة الدراسية للعقد</InputLabel>
            <Select
              value={selectedContractYear}
              onChange={(e) => setSelectedContractYear(e.target.value)}
              label="السنة الدراسية للعقد"
            >
              {contractYears.map((year) => (
                <MenuItem 
                  key={year.id} 
                  value={year.year}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <span>{year.year}</span>
                  {year.isActive && (
                    <Typography 
                      variant="caption" 
                      sx={{ 
                        color: 'success.main',
                        bgcolor: 'success.light',
                        px: 1,
                        py: 0.5,
                        borderRadius: 1,
                        fontSize: '0.75rem',
                        mr: 1
                      }}
                    >
                      نشط
                    </Typography>
                  )}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {/* Path Selection */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" sx={{ mb: 2, color: '#0B3D2E', fontWeight: 'bold' }}>
            المسار التعليمي
          </Typography>
          <Typography variant="body2" sx={{ mb: 3, color: '#666', textAlign: 'center' }}>
            اختر المسار التعليمي المناسب للطالب. المسار الأمريكي يوفر تعليماً بمعايير دولية، بينما المسار الأهلي يركز على القيم الوطنية والتربوية.
          </Typography>
          <div className="row">
            <div className="col-md-6 mb-2">
              <div 
                className={`path-option-card ${selectedPath === 'american' ? 'selected' : ''}`}
                onClick={() => setSelectedPath('american')}
                style={{
                  border: selectedPath === 'american' ? '3px solid #1976d2' : '2px solid #e0e0e0',
                  borderRadius: '12px',
                  padding: '20px',
                  cursor: 'pointer',
                  backgroundColor: selectedPath === 'american' ? '#f3f8ff' : 'white',
                  transition: 'all 0.3s ease',
                  textAlign: 'center',
                  boxShadow: selectedPath === 'american' ? '0 4px 12px rgba(25, 118, 210, 0.2)' : '0 2px 8px rgba(0, 0, 0, 0.1)',
                  transform: selectedPath === 'american' ? 'translateY(-2px)' : 'translateY(0)'
                }}
                onMouseEnter={(e) => {
                  if (selectedPath !== 'american') {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(25, 118, 210, 0.15)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedPath !== 'american') {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
                  }
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '10px' }}>
                  <img 
                    src={require('../../assets/images/AmericanLogoPath.png')} 
                    alt="American Path" 
                    style={{ width: '40px', height: '40px', marginRight: '10px' }}
                  />
                  <span style={{ fontWeight: 'bold', color: '#1976d2' }}>
                    المسار الأمريكي والدبلوم الأمريكي (عالمي)
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-2">
              <div 
                className={`path-option-card ${selectedPath === 'public' ? 'selected' : ''}`}
                onClick={() => setSelectedPath('public')}
                style={{
                  border: selectedPath === 'public' ? '3px solid #0B3D2E' : '2px solid #e0e0e0',
                  borderRadius: '12px',
                  padding: '20px',
                  cursor: 'pointer',
                  backgroundColor: selectedPath === 'public' ? '#f0f9f0' : 'white',
                  transition: 'all 0.3s ease',
                  textAlign: 'center',
                  boxShadow: selectedPath === 'public' ? '0 4px 12px rgba(11, 61, 46, 0.2)' : '0 2px 8px rgba(0, 0, 0, 0.1)',
                  transform: selectedPath === 'public' ? 'translateY(-2px)' : 'translateY(0)'
                }}
                onMouseEnter={(e) => {
                  if (selectedPath !== 'public') {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(11, 61, 46, 0.15)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedPath !== 'public') {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
                  }
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '10px' }}>
                  <img 
                    src={require('../../assets/images/PublicLogoPath.png')} 
                    alt="Public Path" 
                    style={{ width: '40px', height: '40px', marginRight: '10px' }}
                  />
                  <span style={{ fontWeight: 'bold', color: '#0B3D2E' }}>
                    المسار الأهلي (وطني)
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Box>

        <Guardian data={guardian} setData={setGuardian} />
        <hr />
        <ContractEditor data={contractEditor} setData={setContractEditor} />
        <hr />
                  <Student data={student} setData={setStudent} selectedPath={selectedPath} />
        <hr />
        <Payment data={payment} setData={setPayment} />
        <div className="text-center w-100">
          <button
            onClick={handleSubmit}
            className="btn btn-success w-75 text-center edit-button"
          >
            تعديل العقد
          </button>
        </div>
      </div>
      <Footer />
    </>
  );

  function handleSubmit() {
    if (!selectedContractYear) {
      alert('يرجى اختيار السنة الدراسية للعقد');
      return;
    }

    if (!selectedPath) {
      alert('يرجى اختيار المسار التعليمي');
      return;
    }

    const requestData = {
      contractYear: selectedContractYear,
      guardian,
      contractEditor,
      student,
      payment: {
        ...payment,
        isKindergartenAmerican: selectedPath === 'american' && student.requiredStage === 'Kindergarten',
        isElementaryAmerican: selectedPath === 'american' && student.requiredStage === 'Elementary',
      },
    };


    fetch(`${API_URL2}/api/admin/edit/${id}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          // Show success popup
          setShowSuccessPopup(true);
          
          // Navigate to students page after showing popup
          setTimeout(() => {
            navigate("/students");
          }, 2000);
        } else {
          alert(data.message || "حدث خطأ أثناء تعديل العقد.");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        alert("تعذر الاتصال بالخادم.");
      });
  }
}
